import { useCallback, useEffect, useMemo, useState } from 'react'

import { debounce } from 'lodash'
import { Funnel } from 'lucide-react'
import { Label, FormGroup, Button, Col, DefaultPopover, Row, SelectMulti, Separator } from 'twyne-new.ui'

import InputSearchList from '@/components/InputSearchList'
import { useBuilderStore } from '@/components/builder/utils/store'

import { useBlocks } from './hooks'

export default function Filters() {
  return <>
    <div className='flex items-center gap-1'>
      <Term>
        <Filter />
      </Term>
    </div>
    <Separator className='m-0 p-0 my-2' />
  </>
}

function Term({ children }) {
  const { filters: { setSearch } } = useBlocks()

  const [value, setValue] = useState('')

  const debouncedChange = useMemo(() => debounce(setSearch, 500), [setSearch])

  const handleChange = useCallback(value => {
    setValue(value)
    debouncedChange(value)
  }, [debouncedChange])

  return <InputSearchList
    className='flex justify-between gap-2 pr-0'
    placeholder='Search...'
    value={value}
    onChange={handleChange}>
    {children}
  </InputSearchList>
}

function Filter() {
  const { filters: { setFilters } } = useBlocks()
  const { templateBlock: { fetchBlocksTags } } = useBuilderStore()

  const [options, setOptions] = useState([])
  const [open, setOpen] = useState(false)
  const [tags, setTags] = useState([])

  const loadOptions = useCallback(async () => {
    const tags = await fetchBlocksTags()
    setOptions(tags.map(tag => ({ value: tag, label: tag })))
  }, [fetchBlocksTags])

  useEffect(() => {
    loadOptions()
  }, [loadOptions])

  const handleApply = useCallback(() => {
    const tagsFilter = tags.length ? tags.map(({ value }) => value) : null
    setFilters(filters => ({
      ...filters,
      tags: tagsFilter,
    }))
    setOpen(false)
  }, [tags, setFilters])

  return <DefaultPopover
    triggerProps={{ asChild: true }}
    wrapperProps={{ open, onOpenChange: setOpen }}
    contentProps={{ side: 'bottom', align: 'center', className: 'mt-1 w-70' }}
    trigger={<Button variant='ghost' color='accent' size='sm' >
      <Funnel size='14' />
    </Button>}
  >
    <Row>
      <Col size='12'>
        <FormGroup>
          <Label>Tags</Label>
          <SelectMulti value={tags} onChange={setTags} options={options} clearable creatable />
        </FormGroup>
      </Col>
      <Col size='12'>
        <Button block size='sm' color='accent' onClick={handleApply}>Apply</Button>
      </Col>
    </Row>
  </DefaultPopover>
}
